import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { AppService } from 'src/app/core/services/app.service';
import { FocusdataService } from 'src/app/core/services/focusdata.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { ImageCropperService } from 'src/app/core/services/image-cropper.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { MenuItemRecord } from 'src/app/shared/models/focusDataModels/MenuItemRecord';
import { OOCanvasMenuItem } from 'src/app/shared/models/oo-canvas-menu-item.model';
import { OOMenuItem } from 'src/app/shared/models/oo-menu-item';
import { OOMenuItemCanvas } from 'src/app/shared/models/oo-menu-item-canvas.model';
import { OOPriceLevel } from 'src/app/shared/models/oo-price-level';

@Component({
	selector: 'app-menu-item-record-setup',
	templateUrl: './menu-item-record-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class MenuItemRecordSetupComponent implements OnInit, OnDestroy {
	@Input() menuItemKey: number;
	@Input() source: string = 'menuItem';
	@Output() onMenuItemCanvasSaveEmitter: EventEmitter<OOMenuItem> = new EventEmitter<OOMenuItem>();
	@Output() onMenuItemCanvasClearEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

	changesToSave: boolean = false;
	editRow: number;
	ooCanvasMenuItems: OOCanvasMenuItem[];

	lastSave: Date;
	loadComplete: boolean = false;

	menuItem: OOMenuItem;
	menuItemCanvases: OOMenuItemCanvas[];
	menuItemRecord: MenuItemRecord;
	moment: any = moment;

	priceList: any[];
	priceLevel: OOPriceLevel;
	priceLevels: OOPriceLevel[];

	timestamp: number = new Date().getTime();

	unsavedChanges: boolean = false;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusdata: FocusdataService,
		public imgCrop: ImageCropperService,
		public venueSvc: OOVenueService
	) {}
	ngOnDestroy(): void {}

	ngOnInit(): void {
		this.init();

		this.menuItem = this.venueSvc.ooMenuItems.find((i) => i.menuItemKey === this.menuItemKey);
		this.venueSvc.subscriptionOOmenuItems.subscribe((item) => {
			this.menuItem = item.find((i) => i.menuItemKey === this.menuItemKey);
		});
		this.priceList = [
			{
				price1: this.menuItem.price,
				price2: this.menuItem.price2,
				price3: this.menuItem.price3,
				price4: this.menuItem.price4,
				price5: this.menuItem.price5,
				price6: this.menuItem.price6,
				price7: this.menuItem.priceSub,
				price8: this.menuItem.priceExtra,
				price9: this.menuItem.priceNo,
				price10: this.menuItem.priceMod,
			},
		];
	}

	async init() {
		this.menuItemCanvases = await this.venueSvc.menuItemCanvasGet(this.menuItemKey);

		await this.ooGetCanvasesForMenuItem(this.venueSvc.venueKey, this.menuItem.menuItemKey);

		if (this.menuItem.priceLevel) {
			this.ooPriceLevelsGet(this.menuItem.priceLevel);
		}

		this.venueSvc.subscriptionGetMenuItemSubscriptions(this.menuItemKey);
		this.loadComplete = true;
	}

	menuItemPriceValue(value: number) {
		if (value >= 0) {
			value = +value;
			return ` - $${value.toFixed(2)}`;
		} else {
			return '';
		}
	}

	async ooGetCanvasesForMenuItem(venueKey: number, menuItemKey: number) {
		const resp = await this.focuslink.canvasMenuItemGetByMenuItem(venueKey, menuItemKey);
		this.ooCanvasMenuItems = resp.map((i) => {
			const oocmi = new OOCanvasMenuItem(i);
			oocmi.price = this.priceList[0][`price${oocmi.priceNumber}`];
			return oocmi;
		});
		this.ooCanvasMenuItems.forEach((cmi) => {
			cmi.ooCanvas = cmi.ooCanvas || this.venueSvc.ooCanvases.find((can) => can.canvasKey === cmi.canvasKey);
		});

		this.menuItem.ooCanvasMenuItems = this.ooCanvasMenuItems;
	}

	async ooCanvasItemSaveRec(rec: OOCanvasMenuItem) {}

	async ooMenuItemCanvasGet(venueKey, menuItemKey: number) {
		const resp = await this.focuslink.menuItemCanvasGet(venueKey, menuItemKey);
		this.menuItemCanvases = resp.map((i) => {
			return new OOMenuItemCanvas(i);
		});
		this.menuItemCanvases.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
		this.menuItem.ooMenuItemCanvases = this.menuItemCanvases;
	}

	async ooCanvasMenuItemSave(rec: OOCanvasMenuItem) {
		await this.focuslink.canvasMenuItemPost(this.venueSvc.venueKey, rec.canvasKey, rec);
		const listRec = this.ooCanvasMenuItems.find((i) => i.menuItemKey === rec.menuItemKey);
		listRec.unsaved = false;
		this.changesToSave = false;
		this.lastSave = new Date();
	}

	async ooPriceLevelsGet(priceLevelId: number) {
		const resp = await this.focuslink.priceLevelGet(this.venueSvc.venueKey);
		this.priceLevels = resp.map((i) => {
			return new OOPriceLevel(i);
		});
		this.priceLevel = this.priceLevels.find((i) => i.priceLevelKey === priceLevelId);
	}

	async ooMenuItemGet(menuItemKey) {
		const resp = await this.focuslink.menuItemGetOne(this.venueSvc.venueKey, this.menuItem.menuItemKey);
		this.menuItem = new OOMenuItem(resp);
	}

	async onMenuItemSave() {
		this.venueSvc.menuItemsSave(this.menuItem);
		this.unsavedChanges = false;
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `${this.menuItem.name} saved successfully.` });
	}

	async onOOMenuItemCanvasSelect(canvasKey) {
		const index = this.menuItemCanvases.length - 1;
		this.menuItemCanvases[index].canvasKey = canvasKey;
		const canvas = this.venueSvc.ooCanvases.find((i) => i.canvasKey === canvasKey);
		this.menuItemCanvases[index].ooCanvas = canvas;
	}

	async onOOCanvasMenuItemRemove(rec: OOCanvasMenuItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to remove ${rec.ooMenuItem.name}?`,
			header: 'Confirmation',
			icon: 'pi pi-exclamation-triangle',
			accept: async () => {
				await this.focuslink.canvasMenuItemDelete(this.venueSvc.venueKey, rec.canvasKey, rec.menuItemKey);
				const idx = this.ooCanvasMenuItems.findIndex((i) => i.menuItemKey === rec.menuItemKey && i.canvasKey === rec.canvasKey);
				this.ooCanvasMenuItems.splice(idx, 1);
			},
			reject: (type) => {
				this.app.confirmation.close();
			},
		});
	}
}
